export default function extractKeyValuePairs(urlObject) {
  const hash = urlObject.hash;

  if (!hash) {
    return {};
  }

  // Remove the '#' at the beginning of the hash
  const keyValuePairsString = hash.substring(1);
  const keyValuePairsArray = keyValuePairsString.split(":");

  const keyValuePairs = {};

  keyValuePairsArray.forEach(pair => {
    const [key, value] = pair.split("=");
    keyValuePairs[key] = value;
  });

  return keyValuePairs;
}
